import { ApplicationConfig, provideZoneChangeDetection, provideAppInitializer, inject } from '@angular/core';
import { provideRouter, withInMemoryScrolling } from '@angular/router';
import { provideHttpClient, withInterceptors, withFetch } from '@angular/common/http';
import { OAuthModule } from 'angular-oauth2-oidc';
import { importProvidersFrom } from '@angular/core';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';

import { APP_ROUTES } from '@app/app.routes';
// import { AuthInterceptor } from '@auth/auth.interceptor';
// import { ApiErrorInterceptor } from '@core/services/api-error.interceptor';
import { AppConfigService } from '@core/services/app-config.service';
import { EnvironmentService } from '@core/services/environment.service';
import { MultiFileTranslateLoader } from '@core/services/multi-file-translate-loader.service';
import { globalConfig } from '@core/utils/config-loader';
import { GlobalHttpErrorInterceptor } from './core/interceptors/global-http-error.interceptor';
import { AuthHeadersInterceptor } from './core/interceptors/auth-headers.interceptor';

// Factory function for MultiFileTranslateLoader.
export function HttpLoaderFactory() {
	return new MultiFileTranslateLoader();
}

// Export getDefaultRedirectUrl for use in other parts of the app, such as environment.service.ts
// Create a proper initializer function for use with provideAppInitializer
function environmentInitializer() {
	const environmentService = inject(EnvironmentService);

	// Return Promise directly instead of returning a function that returns a Promise
	// First try to load from the global pre-bootstrap config
	if (Object.keys(globalConfig).length) {
		// console.log('Using pre-loaded config:', globalConfig);
	}

	// Then ensure environment service is initialized
	return environmentService.initialize().catch((error) => {
		console.error('Error during app initialization:', error);
		// Return resolved promise to continue app initialization
		return Promise.resolve();
	});
}

export const appConfig: ApplicationConfig = {
	providers: [
		provideZoneChangeDetection({ eventCoalescing: true }),
		provideRouter(APP_ROUTES, withInMemoryScrolling({ scrollPositionRestoration: 'top' })),
		// Include withFetch() to enable modern fetch API for HTTP requests
		provideHttpClient(withFetch(), withInterceptors([AuthHeadersInterceptor, GlobalHttpErrorInterceptor])),

		// Provide core services
		{
			provide: AppConfigService,
			useClass: AppConfigService,
		},
		{
			provide: EnvironmentService,
			useClass: EnvironmentService,
		},

		// Use provideAppInitializer correctly
		provideAppInitializer(environmentInitializer),

		// Import required modules
		importProvidersFrom(
			OAuthModule.forRoot(),
			TranslateModule.forRoot({
				loader: {
					provide: TranslateLoader,
					useFactory: HttpLoaderFactory,
				},
				defaultLanguage: 'en',
			}),
		),
	],
};
